export var ModelErrorCode;
(function (ModelErrorCode) {
    ModelErrorCode[ModelErrorCode["UNION_TYPE_VALUE_MISSING_RUNTIME_TYPE"] = 0] = "UNION_TYPE_VALUE_MISSING_RUNTIME_TYPE";
    ModelErrorCode[ModelErrorCode["UNION_TYPE_VALUE_EXPECTED"] = 1] = "UNION_TYPE_VALUE_EXPECTED";
})(ModelErrorCode || (ModelErrorCode = {}));
export class ModelError extends Error {
    constructor(code, message = 'ModelError') {
        super(message);
        this.code = code;
    }
}
//# sourceMappingURL=ModelError.js.map